// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"cab689f9","254":"4e19c41e","322":"363e7a7f","494":"7ad24d03","535":"183ba931","734":"3cf159d4","861":"8ca16a2d","973":"2f1e709c"}[chunkId] + ".chunk.js";
};